import React, { useEffect, useState } from "react";
import Body from "../../Components/Transaction/FailedTransaction.jsx";
import axiosConfig from "../../ApiCall/axiosConfig";
import { useLocation } from "react-router-dom";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import { MainContainer } from "../../Components/SoftwareMain/MainElements";
const customTheme = "red";

const Index = () => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);

  let location = useLocation();
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get("invoice_code"); // استخراج پارامتر invoice_code
    setLoading(true);
    async function fetchData() {
      const token = localStorage.getItem("tokenManiarApp");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      };
      try {
        const { data } = await axiosConfig.get("/invoice_code/" + code, config);
        setItem(data.data);

        setLoading(false);
      } catch (error) {
        console.log("Error fetching products:", error);
        showError();
        setLoading(false);
      }
    }
    fetchData();
  }, [location]);

  const showError = () => {
    enqueueSnackbar("خطا در اتصال به سرور", {
      autoHideDuration: 2000,
      style: { backgroundColor: "#9A2827" },
    });
  };
  const showWarning = (text) => {
    enqueueSnackbar(text, {
      autoHideDuration: 2000,
      style: { backgroundColor: "#DC981B" },
    });
  };

  return (
    <MainContainer subPage className={customTheme}>
      <SnackbarProvider
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        hideIconVariant={true}
        dense={true}
        maxSnack={1}
        style={{
          fontSize: "14px",
          fontWeight: "900",
          display: "flex",
          justifyContent: "center",
          height: "88px",
          borderRadius: "0",
        }}
      />
      {loading ? (
        <div className="loadingList">
          <div className="spinner"></div>
        </div>
      ) : (
        <Body data={item} showError={showError} showWarning={showWarning} />
      )}
    </MainContainer>
  );
};

export default Index;
